import { Injectable } from '@angular/core';
import { Observable, interval, merge, timer } from 'rxjs';
import { last, map, skipUntil, take } from 'rxjs/operators';
import moment from 'moment';

const toMoment = map(() => moment(new Date()));

@Injectable({ providedIn: 'root' })
export class TimerService {
  readonly topOfMinute$: Observable<moment.Moment>;

  constructor() {
    const startDelayMs = (60 - new Date().getSeconds()) * 1000;
    const minuteMs = 60000;

    const untilNextMinute$ = timer(0, startDelayMs).pipe(take(2));
    const everyMinute$ = interval(minuteMs).pipe(skipUntil(untilNextMinute$.pipe(last())));

    this.topOfMinute$ = merge(untilNextMinute$, everyMinute$).pipe(toMoment);
  }
}
